import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, Observable, tap, throwError } from 'rxjs';
import { ApiService } from '../Apis/api.service';
import { AuthService } from '../Auth/auth.service';


@Injectable()
export class HttpinterceptorService implements HttpInterceptor {


  constructor(private authService : AuthService, private router: Router, private api: ApiService) {


   }

  intercept( req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // if (req.body) {
    //   const duplicate = req.clone({ body: req.body.replace(/pizza/gi, '🍕') });
    //   return next.handle(duplicate);
    // }

    return next.handle(req).pipe(

      tap((event: HttpEvent<any>) => {
        console.log('Incoming HTTP response', event);
      }),
   

      catchError((error: HttpErrorResponse) => {
        // Handle the error here
        var obj = {
          from: error?.url ? error?.url: "NO URL",
          description: error?.error?.message ? error?.error?.message : error?.error?.error ? JSON.stringify(error?.error?.error) : 'No error' 
        }

        console.error('error occurred:', error);
        //throw error as per requiremen
   
       var tm = setTimeout(() => {
          this.createError(obj)
          clearTimeout(tm)
        }, 3000);

        if(error?.status === 401) {
          if(!error.url?.includes('reset')) {
            window.location.href = 'login'
          }
        }
        return throwError(error)
      })
    );

    


//     console.log(this.router.url +" got to interceptor")

//  if(this.router.url != '/login' && !this.router.url.includes('/signup') && !this.router.url.includes('/reset') && (this.router.url != '/vendor/login')) {

//         var activatebool = this.authService.isAuthenticated();

//          console.log(activatebool)
//         if(activatebool == false) {
   
//         window.location.href = 'login'

//         }
//     }
//     return next.handle(req);
//   }
}



createError (obj: any) {
  this.api.createError(obj).then( data => {

       
    return
  })
}
}


// how to use interceptors
// https://www.thirdrocktechkno.com/blog/how-to-integrate-interceptor-in-angular-9/
